import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'meeting-scheduler-settings-calendar',
  templateUrl: './calendar-card.component.html',
  styleUrls: ['./calendar-card.component.scss'],
  standalone: false,
})
export class CalendarCardComponent {
  @Input() enableTracking: boolean;
  @Input() isGoogleConfigured: boolean;
  @Input() isMicrosoftConfigured: boolean;
  @Output() calendarProviderSelected = new EventEmitter<string>();
  handleCalendarProvider(provider: string) {
    this.calendarProviderSelected.emit(provider);
  }
}
